export const EnumEnvironment = {
	PRODUCTION: 1,
	HLOG: 2,
	DEBUG: 3
};
